import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { CrmAlertComponent } from 'src/app/components/fields';
import { Report } from 'src/app/model';
import { LinkedReportProvider, ReportProvider } from 'src/app/providers';
import { SystemType } from 'src/app/model/enums/system.type';
import { ModeService } from 'src/app/services';
import { ReportLink } from 'src/app/model/report-link';
import { LogService } from 'src/app/services';

@Component({
  selector: 'app-report-link',
  templateUrl: './report-link.component.html',
  styleUrls: ['./report-link.component.scss']
})

export class ReportLinkComponent implements OnInit, OnDestroy {

  @ViewChild('alert') alert: CrmAlertComponent;
  subject: Subject<ReportLink>;
  subscription: any;
  selectedReport: Report;
  report: Report;
  showSameReport: boolean = false;

  currentMode: SystemType;
  SystemType = SystemType;
  modeSub: any;

  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    public reportProvider: ReportProvider,
    public linkedReportProvider: LinkedReportProvider,
    private modeService: ModeService,
    private logService : LogService
  ) { }

  ngOnInit(): void {
    this.subscription = this.modalService.onHide.subscribe((reason: string) => {
      if (reason === 'esc') {
        this.onCancel();
      }
    });

    this.modeSub = this.modeService.mode$.subscribe(mode => this.currentMode = mode);
  }

  ngOnDestroy(): void {
    if(this.modeSub)
      this.modeSub.unsubscribe();
  }

  onSelected(value: any): void {
    this.selectedReport = value != null ? value.VALUE : null;

    if(this.selectedReport?.ID === this.report.ID){
      this.alert.showError('Report can\'t be linked to existing report.');
      setTimeout(() => { this.alert.hide(); }, 5000);
    }

    if(this.report.LINKED_REPORTS){
      if(this.report.LINKED_REPORTS?.find((report) => {
        if(report.ID === this.selectedReport?.ID) return report;})){
        this.alert.showError('Selected Report is already linked with this report.');
        setTimeout(() => { this.alert.hide(); }, 5000);
      }
    }
  }

  onConfirm(): void {
    this.alert.hide();
    this.reportProvider.linkReport(this.report.ID, this.selectedReport.ID)
      .subscribe(data => {
        if (data.success) {

          this.bsModalRef.hide();
          this.subject.next(new ReportLink(data.result));
          this.subject.complete();
        } else this.alert.show(data.error);
      }, err => {
        this.alert.show(err);
        this.logService.error(err);
      });
  }

  onCancel(): void {
    this.bsModalRef.hide();
    this.subject.next(null);
    this.subject.complete();
  }
}
